// Components
import OnfsTableInstance from './components/table/OnfsTable'
import OnfsFormInstance from './components/form/OnfsForm'
import OnfsButtonInstance from './components/button/OnfsButton'
import OnfsPrintBtnInstance from './components/button/OnfsPrintBtn'
import OnfsIconBtnInstance from './components/button/OnfsIconBtn'
import OnfsModalInstance from './components/modal/OnfsModal'
import OnfsHeaderInstance from './components/header/OnfsHeader'
import OnfsLinkInstance from './components/link/OnfsLink'
import OnfsLoadingInstance from './components/loading/OnfsLoading'
import useAuthCodeFlowPKCEInstance from './hooks/useAuthCodeFlowPKCE'
import colors from './branding/colors'

// Utilities
import { formatCurrency } from './utilities/Currency'
import { formatDate } from './utilities/Dates'
import { validatePhone } from './utilities/ValidatePhone'
import {
  stripLeadingZeros,
  frontPadWithZerosToLength
} from './utilities/Strings'

export const OnfsTable = OnfsTableInstance
export const OnfsForm = OnfsFormInstance
export const OnfsButton = OnfsButtonInstance
export const OnfsModal = OnfsModalInstance
export const OnfsHeader = OnfsHeaderInstance
export const OnfsLink = OnfsLinkInstance
export const OnfsLoading = OnfsLoadingInstance
export const OnfsPrintBtn = OnfsPrintBtnInstance
export const OnfsIconBtn = OnfsIconBtnInstance
export const useAuthCodeFlowPKCE = useAuthCodeFlowPKCEInstance

export const components = {
  OnfsTable,
  OnfsForm,
  OnfsHeader,
  OnfsModal,
  OnfsButton,
  OnfsLink,
  OnfsLoading,
  OnfsPrintBtn,
  OnfsIconBtn
}

export const branding = { colors }
export const utilities = {
  formatCurrency,
  formatDate,
  stripLeadingZeros,
  frontPadWithZerosToLength,
  validatePhone
}
